import { useEffect, useState } from 'react';
import { Button, FormCheckbox, FormLabel, FormSelect, FormSelectOption, Modal, ModalCloseButton, TextField } from '@tryhackme/thm-ui-components';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { scopesOptions } from 'src/common/constants/admin/tagging';
import { StyledContent, StyledInputWrapper, StyledTitle, StyledWrapper } from 'src/features/admin/manage-users/modals/modals.styles';
import { useForm } from 'src/common/form';
import { StyledActionButtonsWrapper, StyledCheckboxInput, StyledFooterWrapper, StyledInput, StyledScopesSelector } from 'src/features/admin/tagging/tagging.styles';
import { AddTagCategoryModalProps } from 'src/features/admin/tagging/tagging.types';
export const AddTagCategoryModal = ({
  isOpen,
  setIsOpen,
  triggerElement,
  isCreating,
  createdTagCategory,
  resetCreateTagCategory,
  handleCreateTagCategory,
  parentCategory,
  existingCategoryLabels
}: AddTagCategoryModalProps) => {
  const [adminOnlyTagCreation, setAdminOnlyTagCreation] = useState(false);
  const [scopes, setScopes] = useState<FormSelectOption[]>([]);
  const {
    getValues,
    handleSubmit,
    register,
    reset,
    formState: {
      isValid,
      errors
    }
  } = useForm({
    resolver: yupResolver(yup.object({
      label: yup.string().required().test('label', 'Category with this label already exists', value => !existingCategoryLabels.includes(value ?? ''))
    })),
    mode: 'all'
  });
  useEffect(() => {
    if (createdTagCategory && !isCreating) {
      setIsOpen(false);
      reset();
      resetCreateTagCategory();
    }
  }, [reset, createdTagCategory, isCreating, resetCreateTagCategory, setIsOpen]);
  const closeModal = () => {
    setIsOpen(!isOpen);
    reset();
  };
  const onSubmit = () => {
    const values = getValues();
    handleCreateTagCategory({
      label: (values.label as string),
      adminOnlyTagCreation,
      scopes: scopes.map(v => v.value),
      parentCategory,
      subcategories: [],
      created: new Date()
    });
  };
  return <Modal open={isOpen} onOpenChange={closeModal} isSmall triggerElement={triggerElement} overflowVisible data-sentry-element="Modal" data-sentry-component="AddTagCategoryModal" data-sentry-source-file="add-tag-category-modal.tsx">
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form onSubmit={handleSubmit(onSubmit)}>
        <StyledWrapper data-testid="add-tag-category-modal-contents" data-sentry-element="StyledWrapper" data-sentry-source-file="add-tag-category-modal.tsx">
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="add-tag-category-modal.tsx">Add New Tag Category</StyledTitle>
          <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="add-tag-category-modal.tsx">
            <StyledInputWrapper data-sentry-element="StyledInputWrapper" data-sentry-source-file="add-tag-category-modal.tsx">
              <StyledInput data-sentry-element="StyledInput" data-sentry-source-file="add-tag-category-modal.tsx">
                <TextField {...register('label')} id="input-modal-label" variant="input" placeholder="Enter category label..." autoComplete="off" label="Label" labelPosition="left" isRequired isError={!!errors.label?.message} errorMessage={(errors.label?.message as string)} data-sentry-element="TextField" data-sentry-source-file="add-tag-category-modal.tsx" />
              </StyledInput>
              <StyledScopesSelector data-sentry-element="StyledScopesSelector" data-sentry-source-file="add-tag-category-modal.tsx">
                <FormLabel labelPosition="left" variant="toggle" data-sentry-element="FormLabel" data-sentry-source-file="add-tag-category-modal.tsx">
                  Scopes
                </FormLabel>
                <FormSelect id="input-modal-scopes" isMulti selected={scopes} isSearchable={false} handleSelection={newValues => setScopes(newValues.map(value => value))} options={scopesOptions} data-sentry-element="FormSelect" data-sentry-source-file="add-tag-category-modal.tsx" />
              </StyledScopesSelector>
              <StyledCheckboxInput data-sentry-element="StyledCheckboxInput" data-sentry-source-file="add-tag-category-modal.tsx">
                <FormLabel labelPosition="left" variant="toggle" data-sentry-element="FormLabel" data-sentry-source-file="add-tag-category-modal.tsx">
                  Restrict tag creation to THM admins only?
                </FormLabel>
                <FormCheckbox {...register('adminOnlyTagCreation')} checked={adminOnlyTagCreation} onCheckedChange={() => setAdminOnlyTagCreation(prevState => !prevState)} data-sentry-element="FormCheckbox" data-sentry-source-file="add-tag-category-modal.tsx" />
              </StyledCheckboxInput>
            </StyledInputWrapper>
          </StyledContent>
          <StyledFooterWrapper data-sentry-element="StyledFooterWrapper" data-sentry-source-file="add-tag-category-modal.tsx">
            <StyledActionButtonsWrapper data-sentry-element="StyledActionButtonsWrapper" data-sentry-source-file="add-tag-category-modal.tsx">
              <ModalCloseButton text="Cancel" data-sentry-element="ModalCloseButton" data-sentry-source-file="add-tag-category-modal.tsx" />
              <Button type="submit" disabled={!isValid || isCreating} isLoading={isCreating} variant="solid" data-sentry-element="Button" data-sentry-source-file="add-tag-category-modal.tsx">
                Add Category
              </Button>
            </StyledActionButtonsWrapper>
          </StyledFooterWrapper>
        </StyledWrapper>
      </form>
    </Modal>;
};